import React, { Component } from 'react'
import _ from 'underscore'
import { mixinsClassName } from '../../utils'
import { Input } from './base'

export default class extends Component {
    clearText() {
        this.refs.input.clearText();
    }

    render() {
        let { className, iconClassName } = this.props
        let inputProps = _.omit(this.props, 'className', 'iconClassName', 'ref');

        className = mixinsClassName("ui-search-box", className);
        iconClassName = mixinsClassName("icon", iconClassName || 'icon-query');

        return (
            <div className={className}>
                <i className={iconClassName}></i>
                <Input ref="input" {...inputProps}/>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/ui/input/search.js